var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockerActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0398 4.66965L13.5398 2.60965C12.9698 2.39965 12.0398 2.39965 11.4698 2.60965L5.9698 4.66965C4.9098 5.06965 4.0498 6.30965 4.0498 7.43965V15.5396C4.0498 16.3496 4.5798 17.4196 5.2298 17.8996L10.7298 22.0096C11.6998 22.7396 13.2898 22.7396 14.2598 22.0096L19.7598 17.8996C20.4098 17.4096 20.9398 16.3496 20.9398 15.5396V7.43965C20.9498 6.30965 20.0898 5.06965 19.0398 4.66965ZM13.2498 13.3696V15.9996C13.2498 16.4096 12.9098 16.7496 12.4998 16.7496C12.0898 16.7496 11.7498 16.4096 11.7498 15.9996V13.3696C10.7398 13.0496 9.9998 12.1096 9.9998 10.9996C9.9998 9.61965 11.1198 8.49965 12.4998 8.49965C13.8798 8.49965 14.9998 9.61965 14.9998 10.9996C14.9998 12.1196 14.2598 13.0496 13.2498 13.3696Z",
    fill: "url(#paint0_linear_4943_61724)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4943_61724",
    x1: 12.4948,
    y1: 2.45215,
    x2: 12.4948,
    y2: 22.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerActive);
export default __webpack_public_path__ + "static/media/locker-active.1310509d34c46e8a5a12828207f9513d.svg";
export { ForwardRef as ReactComponent };